import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { u as o, a as n } from "./index-6a632112.mjs";
import m from "react";
import "./themes-5f0b3c3d.mjs";
import { a as D, b as F } from "./superScript-393c70dc.mjs";
import { h as O } from "./hTag-40b23797.mjs";
import { Grid as p } from "./grid.js";
import { Tooltip as W } from "./tooltip.js";
import { S as P } from "./informationFilled-05d57719.mjs";
import { c as s } from "./index-98c703e1.mjs";
import "./uniqueId-321287e8.mjs";
import "./useWindowDimensions.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./types-b577bf77.mjs";
import "./_commonjsHelpers-d4512b9c.mjs";
const T = o.div`
  &.section-mainWrapper {
    ${({
  theme: {
    components: { readOnlySection: e }
  }
}) => n(e.FordProDefaultReadOnlySection.MainWrapper)};

    ${D()}
    ${F()}
  }
`, v = o.div`
  ${({
  theme: {
    components: { readOnlySection: e }
  }
}) => n(e.FordProDefaultReadOnlySection.HeaderSection)};
`, b = o(O)`
  && {
    ${({
  theme: {
    components: { readOnlySection: e }
  }
}) => n(e.FordProDefaultReadOnlySection.SectionTitle)};
  }
`, I = o.div`
  ${({
  theme: {
    components: { readOnlySection: e }
  }
}) => n(e.FordProDefaultReadOnlySection.Subtitle)};
`, g = o.div`
  ${({
  theme: {
    components: { readOnlySection: e }
  }
}) => n(e.FordProDefaultReadOnlySection.Description)};
`, C = o.div`
  ${({
  theme: {
    components: { readOnlySection: e }
  }
}) => n(e.FordProDefaultReadOnlySection.SecondaryLabel)};
`, w = o.div`
  ${({
  theme: {
    components: { readOnlySection: e }
  }
}) => n(e.FordProDefaultReadOnlySection.ContentWrapper)};
`, x = o.div`
  ${({
  theme: {
    components: { readOnlySection: e }
  }
}) => n(e.FordProDefaultReadOnlySection.RowItemWrapper)};
`, L = o.div`
  ${({
  theme: {
    components: { readOnlySection: e }
  }
}) => n(e.FordProDefaultReadOnlySection.RowItemTitle)};
`, G = o.div`
  ${({
  theme: {
    components: { readOnlySection: e }
  }
}) => n(e.FordProDefaultReadOnlySection.RowTitleWrapper)};
`, N = o(p)`
  &.grid--Content {
    ${({
  theme: {
    components: { readOnlySection: e }
  }
}) => n(e.FordProDefaultReadOnlySection.GridContent)};
  }
`, d = ({ label: e, infoText: t, value: c }) => /* @__PURE__ */ a(x, { "data-testid": "Items", children: [
  /* @__PURE__ */ a(G, { children: [
    /* @__PURE__ */ r(L, { children: e }),
    t && /* @__PURE__ */ r(W, { placement: "auto", title: t, children: /* @__PURE__ */ r(P, { size: "xxs" }) })
  ] }),
  /* @__PURE__ */ r(w, { children: c })
] }), j = ({
  className: e,
  header: t,
  children: c,
  columnOptions: u = { xl: 2, l: 4, m: 6, s: 12 },
  variant: l = "Condensed"
}) => {
  const { xl: S, l: f, m: y, s: R } = u, h = () => /* @__PURE__ */ r(
    N,
    {
      className: s([[`grid--Content--${l}`]]),
      gutterWidth: 24,
      children: m.Children.map(c, (i, $) => i && m.isValidElement(i) && i.type === d ? /* @__PURE__ */ r(p.Item, { xl: S, l: f, m: y, s: R, children: i }, $) : null)
    }
  );
  return /* @__PURE__ */ a(
    T,
    {
      className: s([
        [
          `${e}`,
          "section-mainWrapper",
          `section-mainWrapper--${l}`
        ]
      ]),
      children: [
        /* @__PURE__ */ a(v, { "data-testid": "headersection", children: [
          t?.title && /* @__PURE__ */ r(b, { as: t?.headingLevel, children: t?.title }),
          t?.subTitle && /* @__PURE__ */ r(I, { children: t?.subTitle }),
          t?.description && /* @__PURE__ */ r(g, { children: t?.description }),
          t?.secondaryLabel && /* @__PURE__ */ r(C, { children: t?.secondaryLabel })
        ] }),
        h()
      ]
    }
  );
};
j.Item = d;
export {
  j as ReadOnlySection
};
